import { createFileRoute, redirect } from '@tanstack/react-router'
import { WorkSchedulesScreen } from '@/features/hr-settings/work-schedules-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/work-schedules')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'attendance.view')) throw redirect({ to: '/' })
  },
  component: WorkSchedulesScreen,
})
